// @flow
import type {DataTables} from 'datatables.net';

export default function className(column: String, options: any,
    dtSettings: DataTables.Settings, component: JQuery) {
        let col = dtSettings.columns.find(c => c.title == column);
        col.className = options;
}